var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{staticClass:"ext-link",on:{"click":_vm.onExtLink}},[_c('img',{staticClass:"link",style:({width: _vm.size + 'rem'}),attrs:{"src":require("@/assets/icons/ico-link.svg")}})])
}
var staticRenderFns = []

export { render, staticRenderFns }